<div
    class="input-group"
    [class.dropdown-open]="dropdownVisible"
    [ngClass]="{
        'period-type': type === 'period',
        'status-type': type === 'status',
        'input-type': type === 'input',
        'dropdown-active': dropdownVisible && (type === 'period' || type === 'status')
    }">

    <label *ngIf="label" [for]="controlId">
        {{ label }}<span *ngIf="required" class="required"> * </span>
    </label>

    <div class="input-wrapper">
        <div
            class="form-field readonly-trigger"
            tabindex="0"
            [class.disabled]="disabled"
            (click)="toggleDropdown($event)"
            (blur)="onDropdownBlur()">

            <span class="trigger-text">
                <span class="trigger-text-inner">
                    {{ selectedOption ? displayWith(selectedOption) : placeholder }}
                </span>
            </span>

            <button
                *ngIf="selectedOption && type === 'input' && !disabled"
                type="button"
                class="icon-button"
                (click)="clearSelection($event)">
                <i class="fas fa-times"></i>
            </button>

            <i class="fas fa-chevron-down dropdown-icon" [class.open]="dropdownVisible"></i>
        </div>

        <div class="autocomplete-wrapper" [class.open]="dropdownVisible">
            <ul #dropdownList class="autocomplete-dropdown" [class.open]="dropdownVisible" [class.disabled]="disabled">
                <ng-container *ngIf="type !== 'status'">
                    <li class="filter-input">
                        <input
                            #searchInput
                            type="text"
                            [(ngModel)]="searchText"
                            (input)="onInputChange()"
                            (blur)="onDropdownBlur()"
                            placeholder="Search..."
                            [disabled]="disabled"
                            autocomplete="new-password"/>
                    </li>
                    <hr class="separator"/>
                </ng-container>

                <li
                    *ngFor="let option of filteredOptions"
                    (mousedown)="selectOption(option)"
                    [class.disabled]="disabled">

                    {{ displayWith(option) }}
                </li>
            </ul>
        </div>

        <div *ngIf="invalid">
            <span class="error">{{ validationMessage }}</span>
        </div>
    </div>
</div>